<template>
    <div :class="{'product--show-panel': usePanels, 'product--hide-panel': !usePanels}">
        <slot></slot>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      isDetail: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    computed: {
      ...mapGetters({
        shop: 'shop/get',
        isMobile: 'shop/getMetaIsMobile'
      }),
      usePanels () {
        if (this.$route.params.id) return this.usePanelsDetail
        return this.usePanelsOverview
      },
      usePanelsOverview () {
        if (this.isMobile) return this.shop.display_mobile_overview_use_panels
        return this.shop.display_desktop_overview_use_panels
      },
      usePanelsDetail () {
        if (this.isMobile) return this.shop.display_mobile_detail_use_panels
        return this.shop.display_desktop_detail_use_panels
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/ui/productPanel.vue